<!-- ── Admin top bar ──────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">

    <!-- Nav links — horizontal scroll on mobile -->
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <a routerLink="/admin/scraper"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Scraper</a>
      <a routerLink="/admin/vacantes"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Vacantes</a>
      <a routerLink="/admin/usuarios"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Usuarios</a>
      <a routerLink="/admin/gurumatch"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <a routerLink="/admin/suscripciones"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Suscripciones</a>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Config</span>
      <a routerLink="/admin/social"
         style="font-size:13px;color:#94a3b8;text-decoration:none;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Redes Sociales</a>
    </div>

    <!-- Action buttons — always visible -->
    <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;margin-left:8px;">
      <button (click)="cerrarSesion()"
              style="display:inline-flex;align-items:center;gap:5px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/>
        </svg>
        Salir
      </button>
    </div>
  </div>
</div>

<!-- ── Contenido ──────────────────────────────────────────────────────────── -->
<div style="background:#f1f5f9;min-height:calc(100vh - 116px);padding:32px 0;">
  <div class="tg-container" style="max-width:760px;">

    <h1 style="font-size:1.4rem;font-weight:700;color:#0f172a;margin:0 0 6px;">Configuración de integraciones</h1>
    <p style="color:#64748b;font-size:13.5px;margin:0 0 28px;">
      Google OAuth, LinkedIn OAuth y Stripe se configuran aquí y se guardan en base de datos.
      Los valores sensibles se muestran enmascarados; escribe uno nuevo para reemplazarlo.
    </p>

    <!-- ── Pestañas ─────────────────────────────────────────────────────── -->
    <div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:24px;">
      <button *ngFor="let t of tabs" type="button" (click)="activeTab = t.id"
              [style.background]="activeTab === t.id ? '#0ea5e9' : '#e2e8f0'"
              [style.color]="activeTab === t.id ? '#fff' : '#64748b'"
              style="border:none;border-radius:8px;padding:9px 16px;font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap;">
        {{ t.label }}
      </button>
    </div>

    <!-- ── Google OAuth ─────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'login'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" style="width:22px;height:22px;" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Google OAuth 2.0</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Login con Google para candidatos</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.googleSet" [class.cfg-badge--warn]="!cfg.googleSet">
          {{ cfg.googleSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">
        <label class="cfg-label">Client ID
          <small>Obtenerlo en <a href="https://console.cloud.google.com" target="_blank">console.cloud.google.com</a> → APIs y servicios → Credenciales</small>
        </label>
        <input [(ngModel)]="cfg.googleClientId" type="text" class="cfg-input"
               placeholder="448396917451-xxxxxxxxxxxx.apps.googleusercontent.com">

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.google.ok" class="cfg-ok">✓ {{sections.google.ok}}</span>
            <span *ngIf="sections.google.err" class="cfg-err">{{sections.google.err}}</span>
          </div>
          <button (click)="guardar('google')" [disabled]="sections.google.saving" class="cfg-btn">
            <svg *ngIf="sections.google.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.google.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── LinkedIn OAuth ───────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'login'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="#0A66C2" style="width:22px;height:22px;">
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
            <circle cx="4" cy="4" r="2"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">LinkedIn OAuth 2.0</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Login con LinkedIn para candidatos</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.linkedinSet" [class.cfg-badge--warn]="!cfg.linkedinSet">
          {{ cfg.linkedinSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">
        <p style="font-size:12px;color:#64748b;margin:0 0 16px;padding:10px 12px;background:#f8fafc;border-radius:8px;border:1px solid #e2e8f0;">
          Obtener credenciales en <a href="https://www.linkedin.com/developers/apps" target="_blank" style="color:#0A66C2;">linkedin.com/developers/apps</a> →
          tu app → Auth. La redirect URI que registres en LinkedIn debe coincidir con el campo de abajo.
        </p>

        <label class="cfg-label">Client ID</label>
        <input [(ngModel)]="cfg.linkedinClientId" type="text" class="cfg-input" placeholder="78ahfqvru6ng0v">

        <label class="cfg-label" style="margin-top:14px;">Client Secret
          <small>Se enmascara al guardar. Escribe el nuevo valor para actualizarlo.</small>
        </label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.linkedinClientSecret" [type]="show['linkedinClientSecret'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="WPL_AP1.xxxxxxx">
          <button (click)="toggleShow('linkedinClientSecret')" [disabled]="loadingTokens && !show['linkedinClientSecret']" [title]="show['linkedinClientSecret'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg *ngIf="!show['linkedinClientSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
            <svg *ngIf="show['linkedinClientSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
          </button>
        </div>

        <label class="cfg-label" style="margin-top:14px;">Redirect URI</label>
        <input [(ngModel)]="cfg.linkedinRedirectUri" type="text" class="cfg-input"
               placeholder="https://tg-empleos.tgconsulting.online/oauth/callback/linkedin">

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.linkedin.ok" class="cfg-ok">✓ {{sections.linkedin.ok}}</span>
            <span *ngIf="sections.linkedin.err" class="cfg-err">{{sections.linkedin.err}}</span>
          </div>
          <button (click)="guardar('linkedin')" [disabled]="sections.linkedin.saving" class="cfg-btn">
            <svg *ngIf="sections.linkedin.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.linkedin.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── Stripe ───────────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'pagos'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" style="width:22px;height:22px;" fill="#635BFF">
            <path d="M13.479 9.883c-1.626-.604-2.512-1.067-2.512-1.803 0-.622.518-1.03 1.352-1.03 1.553 0 3.144.635 4.24 1.178l.62-3.836C15.952 3.736 14.315 3 11.857 3 8.96 3 7 4.632 7 7.104c0 2.588 1.757 3.713 4.286 4.632 1.681.604 2.213 1.086 2.213 1.803 0 .667-.5 1.086-1.534 1.086-1.4 0-3.215-.7-4.5-1.503l-.668 3.87C8.113 17.913 9.857 18.5 12.23 18.5c3.088 0 5.123-1.554 5.123-4.062 0-2.544-1.574-3.78-3.874-4.555z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Stripe — Pagos Premium</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Suscripción mensual de candidatos</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.stripeSet" [class.cfg-badge--warn]="!cfg.stripeSet">
          {{ cfg.stripeSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">

        <!-- Guía paso a paso Stripe -->
        <div style="font-size:12px;color:#475569;margin:0 0 20px;border:1px solid #e2e8f0;border-radius:10px;overflow:hidden;">
          <div style="background:#635BFF;color:#fff;padding:8px 14px;font-weight:700;font-size:12px;letter-spacing:.4px;">
            GUÍA DE CONFIGURACIÓN — PASO A PASO
          </div>

          <!-- Test vs Producción -->
          <div style="padding:10px 14px;background:#faf5ff;border-bottom:1px solid #e2e8f0;">
            <span style="font-weight:700;color:#635BFF;">Test vs Producción:</span>
            usa claves <code style="background:#ede9fe;padding:1px 5px;border-radius:4px;">sk_test_...</code> para pruebas y
            <code style="background:#ede9fe;padding:1px 5px;border-radius:4px;">sk_live_...</code> para producción real.
            Los Price IDs y el Webhook también son distintos entre ambos entornos.
          </div>

          <!-- Paso 1 -->
          <div style="padding:10px 14px;border-bottom:1px solid #e2e8f0;">
            <div style="font-weight:700;color:#0f172a;margin-bottom:4px;">
              <span style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;background:#635BFF;color:#fff;border-radius:50%;font-size:10px;margin-right:6px;">1</span>
              Obtener la Secret Key (API Key)
            </div>
            <ol style="margin:0;padding-left:20px;line-height:2;">
              <li>Entra a <a href="https://dashboard.stripe.com" target="_blank" style="color:#635BFF;">dashboard.stripe.com</a></li>
              <li>Menú izquierdo → <strong>Developers → API keys</strong></li>
              <li>Copia la <strong>Secret key</strong> (empieza con <code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">sk_test_</code> o <code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">sk_live_</code>)</li>
              <li>Pégala en el campo <em>Secret Key</em> de abajo</li>
            </ol>
          </div>

          <!-- Paso 2 -->
          <div style="padding:10px 14px;border-bottom:1px solid #e2e8f0;">
            <div style="font-weight:700;color:#0f172a;margin-bottom:4px;">
              <span style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;background:#635BFF;color:#fff;border-radius:50%;font-size:10px;margin-right:6px;">2</span>
              Crear el producto y obtener los Price IDs
            </div>
            <ol style="margin:0;padding-left:20px;line-height:2;">
              <li>Menú izquierdo → <strong>Product catalog</strong> → <strong>+ Add product</strong></li>
              <li>Nombre: <code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">Premium TG Empleos</code></li>
              <li>En <strong>Pricing</strong>, clic <strong>Add a price</strong>:
                <ul style="padding-left:16px;margin:2px 0;">
                  <li>Precio: <strong>$19.00 USD</strong> — período: <strong>Monthly</strong> → guardar</li>
                  <li>Clic <strong>Add a price</strong> de nuevo → <strong>$190.00 USD</strong> — período: <strong>Yearly</strong> → guardar</li>
                </ul>
              </li>
              <li>Clic <strong>Save product</strong></li>
              <li>En el producto guardado, expande cada precio — copia el <strong>Price ID</strong> (<code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">price_1Abc...</code>)</li>
              <li>Pega cada Price ID en los campos correspondientes de abajo</li>
            </ol>
          </div>

          <!-- Paso 3 -->
          <div style="padding:10px 14px;">
            <div style="font-weight:700;color:#0f172a;margin-bottom:4px;">
              <span style="display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;background:#635BFF;color:#fff;border-radius:50%;font-size:10px;margin-right:6px;">3</span>
              Registrar el Webhook y obtener el Webhook Secret
            </div>
            <ol style="margin:0;padding-left:20px;line-height:2;">
              <li>Menú izquierdo → <strong>Developers → Webhooks</strong> → <strong>+ Add endpoint</strong></li>
              <li>En <em>Endpoint URL</em> escribe:<br>
                <code style="background:#f1f5f9;padding:2px 6px;border-radius:3px;word-break:break-all;">https://tg-empleos.tgconsulting.online/tg-empleo/publico/stripe/webhook</code>
              </li>
              <li>En <em>Select events</em> marca estos 4 eventos:
                <ul style="padding-left:16px;margin:2px 0;">
                  <li><code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">checkout.session.completed</code></li>
                  <li><code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">customer.subscription.updated</code></li>
                  <li><code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">customer.subscription.deleted</code></li>
                  <li><code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">invoice.payment_failed</code></li>
                </ul>
              </li>
              <li>Clic <strong>Add endpoint</strong></li>
              <li>Abre el endpoint recién creado → sección <em>Signing secret</em> → clic <strong>Reveal</strong></li>
              <li>Copia el valor (<code style="background:#f1f5f9;padding:1px 4px;border-radius:3px;">whsec_...</code>) y pégalo en <em>Webhook Secret</em> de abajo</li>
            </ol>
          </div>
        </div>

        <!-- Stripe Mode Toggle + Keys -->
        <label class="cfg-label" style="margin-top:14px;">Modo de Stripe</label>
        <div style="display:flex;gap:10px;margin-top:6px;">
          <button type="button" (click)="cfg.stripeMode='test'"
                  [style.background]="cfg.stripeMode==='test' ? '#f59e0b' : '#e2e8f0'"
                  [style.color]="cfg.stripeMode==='test' ? '#fff' : '#64748b'"
                  style="border:none;border-radius:6px;padding:6px 16px;font-weight:600;cursor:pointer;font-size:12px;">
            🧪 TEST
          </button>
          <button type="button" (click)="cfg.stripeMode='live'"
                  [style.background]="cfg.stripeMode==='live' ? '#10b981' : '#e2e8f0'"
                  [style.color]="cfg.stripeMode==='live' ? '#fff' : '#64748b'"
                  style="border:none;border-radius:6px;padding:6px 16px;font-weight:600;cursor:pointer;font-size:12px;">
            🚀 LIVE
          </button>
        </div>
        <small style="color:#94a3b8;font-size:11px;margin-top:3px;display:block;">{{ cfg.stripeMode==='live' ? 'Usando claves de produccion' : 'Usando claves de prueba' }}</small>

        <!-- Test Keys (shown in test mode) -->
        <ng-container *ngIf="cfg.stripeMode==='test'">
          <label class="cfg-label" style="margin-top:14px;">Secret Key TEST (sk_test_...)</label>
          <div style="display:flex;align-items:center;gap:6px;">
            <input [(ngModel)]="cfg.stripeTestApiKey" [type]="show['stripeTestApiKey'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="sk_test_xxxxxxxxxxxxxxxx">
            <button (click)="toggleShow('stripeTestApiKey')" [disabled]="loadingTokens && !show['stripeTestApiKey']" [title]="show['stripeTestApiKey'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
              <svg *ngIf="!show['stripeTestApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
              <svg *ngIf="show['stripeTestApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
            </button>
          </div>
          <label class="cfg-label" style="margin-top:10px;">Public Key TEST (pk_test_...)</label>
          <input [(ngModel)]="cfg.stripeTestPublicKey" type="text" class="cfg-input" placeholder="pk_test_xxxxxxxxxxxxxxxx">
          <label class="cfg-label" style="margin-top:10px;">Webhook Secret TEST (whsec_...)</label>
          <div style="display:flex;align-items:center;gap:6px;">
            <input [(ngModel)]="cfg.stripeTestWebhookSecret" [type]="show['stripeTestWebhookSecret'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="whsec_xxxxxxxxxxxxxxxx">
            <button (click)="toggleShow('stripeTestWebhookSecret')" [disabled]="loadingTokens && !show['stripeTestWebhookSecret']" [title]="show['stripeTestWebhookSecret'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
              <svg *ngIf="!show['stripeTestWebhookSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
              <svg *ngIf="show['stripeTestWebhookSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
            </button>
          </div>
          <label class="cfg-label" style="margin-top:10px;">Price ID Mensual TEST</label>
          <input [(ngModel)]="cfg.stripeTestPriceIdMonthly" type="text" class="cfg-input" placeholder="price_test_...">
          <label class="cfg-label" style="margin-top:10px;">Price ID Anual TEST</label>
          <input [(ngModel)]="cfg.stripePriceIdAnnual" type="text" class="cfg-input" placeholder="price_test_...">
        </ng-container>

        <!-- Live Keys (shown in live mode) -->
        <ng-container *ngIf="cfg.stripeMode==='live'">
          <label class="cfg-label" style="margin-top:14px;">Secret Key LIVE (sk_live_...)</label>
          <div style="display:flex;align-items:center;gap:6px;">
            <input [(ngModel)]="cfg.stripeApiKey" [type]="show['stripeApiKey'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="sk_live_xxxxxxxxxxxxxxxx">
            <button (click)="toggleShow('stripeApiKey')" [disabled]="loadingTokens && !show['stripeApiKey']" [title]="show['stripeApiKey'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
              <svg *ngIf="!show['stripeApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
              <svg *ngIf="show['stripeApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
            </button>
          </div>
          <label class="cfg-label" style="margin-top:10px;">Public Key LIVE (pk_live_...)</label>
          <input [(ngModel)]="cfg.stripePublicKey" type="text" class="cfg-input" placeholder="pk_live_xxxxxxxxxxxxxxxx">
          <label class="cfg-label" style="margin-top:10px;">Webhook Secret LIVE (whsec_...)</label>
          <div style="display:flex;align-items:center;gap:6px;">
            <input [(ngModel)]="cfg.stripeWebhookSecret" [type]="show['stripeWebhookSecret'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="whsec_xxxxxxxxxxxxxxxx">
            <button (click)="toggleShow('stripeWebhookSecret')" [disabled]="loadingTokens && !show['stripeWebhookSecret']" [title]="show['stripeWebhookSecret'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
              <svg *ngIf="!show['stripeWebhookSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
              <svg *ngIf="show['stripeWebhookSecret']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
            </button>
          </div>
          <label class="cfg-label" style="margin-top:10px;">Price ID Mensual LIVE</label>
          <input [(ngModel)]="cfg.stripePriceIdMonthly" type="text" class="cfg-input" placeholder="price_1Nxxxxxxxxxxxxxxxx">
          <label class="cfg-label" style="margin-top:10px;">Price ID Anual LIVE</label>
          <input [(ngModel)]="cfg.stripePriceIdAnnual" type="text" class="cfg-input" placeholder="price_1Nxxxxxxxxxxxxxxxx">
        </ng-container>

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.stripe.ok" class="cfg-ok">✓ {{sections.stripe.ok}}</span>
            <span *ngIf="sections.stripe.err" class="cfg-err">{{sections.stripe.err}}</span>
          </div>
          <button (click)="guardar('stripe')" [disabled]="sections.stripe.saving" class="cfg-btn">
            <svg *ngIf="sections.stripe.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.stripe.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── WhatzMeAPI ───────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'notificaciones'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 448 512" fill="#25D366" style="width:22px;height:22px;">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L1.9 480l117.7-30.9c32.4 17.7 68.9 27 106.2 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.7-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.8-9.7-10.2-13.4-10.4-3.5-.2-7.5-.2-11.5-.2-4 0-10.5 1.5-16 7.4-5.5 5.9-21.1 20.6-21.1 49.7 0 29.1 21.1 57.4 24 61.6 2.9 4.2 39.4 60.2 95.8 82 56.4 21.8 56.4 14.5 66.5 13.6 10.2-.9 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-4-10.5-6.7z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">WhatzMeAPI — Alertas WhatsApp</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Token para envío de alertas premium por WhatsApp</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.whatzmeSet" [class.cfg-badge--warn]="!cfg.whatzmeSet">
          {{ cfg.whatzmeSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">
        <div style="font-size:12px;color:#475569;margin:0 0 16px;padding:10px 12px;background:#f0fdf4;border-radius:8px;border:1px solid #bbf7d0;">
          <strong>Importante:</strong> la Base URL <strong>debe incluir <code style="background:#dcfce7;padding:1px 4px;border-radius:3px;">/basic</code></strong>
          porque el sistema agrega <code style="background:#dcfce7;padding:1px 4px;border-radius:3px;">/enviar-mensaje</code> y
          <code style="background:#dcfce7;padding:1px 4px;border-radius:3px;">/enviar-archivo</code> al final.<br>
          URL correcta: <code style="background:#dcfce7;padding:1px 5px;border-radius:3px;">https://api.whatzmeapi.com/basic</code>
        </div>

        <label class="cfg-label">Token de API
          <small>Se enmascara. Escribe el nuevo valor para reemplazarlo.</small>
        </label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.whatzmeToken" [type]="show['whatzmeToken'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="Sabb58ab2...">
          <button (click)="toggleShow('whatzmeToken')" [disabled]="loadingTokens && !show['whatzmeToken']" [title]="show['whatzmeToken'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg *ngIf="!show['whatzmeToken']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
            <svg *ngIf="show['whatzmeToken']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
          </button>
        </div>

        <label class="cfg-label" style="margin-top:14px;">Base URL</label>
        <input [(ngModel)]="cfg.whatzmeBaseUrl" type="text" class="cfg-input"
               placeholder="https://api.whatzmeapi.com/basic">

        <label class="cfg-label" style="margin-top:14px;">Números de WhatsApp de administradores
          <small>Separados por comas. Reciben la notificación de cada corrida del scraper (errores, costo y quién/cuándo la ejecutó).</small>
        </label>
        <input [(ngModel)]="cfg.whatsappAdminNumbers" type="text" class="cfg-input"
               placeholder="5215512345678, 5215587654321">

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.whatzme.ok" class="cfg-ok">✓ {{sections.whatzme.ok}}</span>
            <span *ngIf="sections.whatzme.err" class="cfg-err">{{sections.whatzme.err}}</span>
          </div>
          <button (click)="guardar('whatzme')" [disabled]="sections.whatzme.saving" class="cfg-btn">
            <svg *ngIf="sections.whatzme.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.whatzme.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── DeepSeek IA ────────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'ia'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" style="width:22px;height:22px;">
            <circle cx="12" cy="12" r="10" stroke="#4f46e5" stroke-width="1.8"/>
            <path stroke="#4f46e5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
                  d="M8 12h.01M12 12h.01M16 12h.01M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">DeepSeek — IA para scraper y CV</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Token para normalizar vacantes y optimizar CVs</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.deepseekSet" [class.cfg-badge--warn]="!cfg.deepseekSet">
          {{ cfg.deepseekSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">
        <p style="font-size:12px;color:#64748b;margin:0 0 16px;padding:10px 12px;background:#f8fafc;border-radius:8px;border:1px solid #e2e8f0;">
          Obtener en <a href="https://platform.deepseek.com/api_keys" target="_blank" style="color:#4f46e5;">platform.deepseek.com/api_keys</a>.
          Usa el modelo <strong>deepseek-v4-flash</strong> — es el más económico y suficiente para normalización y análisis de CV.
          Sin este token el scraper guarda vacantes sin descripción, categoría ni seniority.
        </p>

        <label class="cfg-label">API Key
          <small>Se enmascara al guardar. Escribe el nuevo valor para actualizarlo.</small>
        </label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.deepseekApiKey" [type]="show['deepseekApiKey'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="sk-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx">
          <button (click)="toggleShow('deepseekApiKey')" [disabled]="loadingTokens && !show['deepseekApiKey']" [title]="show['deepseekApiKey'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg *ngIf="!show['deepseekApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
            <svg *ngIf="show['deepseekApiKey']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
          </button>
        </div>
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testDeepseek()" [disabled]="dsTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="dsTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ dsTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="dsTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{dsTestOk}}</p>
          <p *ngIf="dsTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{dsTestErr}}</p>
        </div>

        <div style="margin-top:18px;padding-top:14px;border-top:1px solid #e2e8f0;">
          <label class="cfg-label">Antigüedad máxima de vacantes en bolsa
            <small>Vacantes con más de este número de meses no se muestran en /vacantes</small>
          </label>
          <div style="display:flex;align-items:center;gap:8px;">
            <input type="number" [(ngModel)]="cfg.mesesVacantes" min="1" max="24" class="cfg-input"
                   style="width:80px;" placeholder="3">
            <span style="font-size:13px;color:#64748b;">mes(es)</span>
          </div>
        </div>

        <div style="margin-top:14px;padding-top:14px;border-top:1px solid #e2e8f0;">
          <label class="cfg-label">Ventana de horas para GuruMatch y alertas
            <small>Solo se consideran vacantes scrapeadas en las últimas X horas al ejecutar GuruMatch o enviar alertas</small>
          </label>
          <div style="display:flex;align-items:center;gap:8px;">
            <input type="number" [(ngModel)]="cfg.horasVacantesRecientes" min="1" max="720" class="cfg-input"
                   style="width:80px;" placeholder="48">
            <span style="font-size:13px;color:#64748b;">hora(s)</span>
          </div>
        </div>

        <div style="margin-top:14px;padding-top:14px;border-top:1px solid #e2e8f0;">
          <label class="cfg-label">Score mínimo GuruMatch (%)
            <small>Vacantes con menos de este % de compatibilidad no aparecen en los resultados del candidato</small>
          </label>
          <div style="display:flex;align-items:center;gap:8px;">
            <input type="number" [(ngModel)]="cfg.guruMatchMinScore" min="1" max="99" class="cfg-input"
                   style="width:80px;" placeholder="80">
            <span style="font-size:13px;color:#64748b;">%</span>
          </div>
        </div>

        <div style="margin-top:14px;padding-top:14px;border-top:1px solid #e2e8f0;">
          <label class="cfg-label">Máximo de resultados GuruMatch
            <small>Cuántas vacantes se muestran al candidato y se envían en alertas (default: 10)</small>
          </label>
          <div style="display:flex;align-items:center;gap:8px;">
            <input type="number" [(ngModel)]="cfg.guruMatchMaxResults" min="1" max="50" class="cfg-input"
                   style="width:80px;" placeholder="10">
            <span style="font-size:13px;color:#64748b;">vacantes</span>
          </div>
        </div>

        <div style="margin-top:14px;padding-top:14px;border-top:1px solid #e2e8f0;">
          <label class="cfg-label">Duración de sesión (horas)
            <small>Tiempo antes de que el token JWT expire y el usuario deba iniciar sesión de nuevo</small>
          </label>
          <div style="display:flex;align-items:center;gap:8px;">
            <input type="number" [(ngModel)]="cfg.jwtExpirationHours" min="1" max="720" class="cfg-input"
                   style="width:80px;" placeholder="8">
            <span style="font-size:13px;color:#64748b;">hora(s) — aplica al próximo login</span>
          </div>
        </div>

        <!-- ── Límites de Planes ─────────────────────────── -->
        <div style="margin-top:20px;padding-top:16px;border-top:2px solid #e2e8f0;">
          <p style="font-size:12px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.6px;margin:0 0 14px;">
            Límites de Planes
          </p>

          <div style="display:grid;grid-template-columns:1fr 1fr;gap:14px;">

            <!-- FREE -->
            <div style="background:#f8fafc;border-radius:8px;padding:14px;border:1px solid #e2e8f0;">
              <p style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;margin:0 0 12px;">Plan Free</p>
              <div style="display:flex;flex-direction:column;gap:10px;">
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">Alertas / mes
                    <small>Cuántas alertas puede recibir al mes</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeAlertLimit" min="0" max="99" class="cfg-input" style="width:70px;" placeholder="2">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">GuruMatch / mes
                    <small>Usos del botón GuruMatch</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeGuruMatchLimit" min="0" max="99" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">CV Optimizer / mes
                    <small>Análisis de CV con IA</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeCvOptimizerLimit" min="0" max="99" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">CVs almacenados
                    <small>Máximo de CVs guardados</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeCvLimit" min="1" max="20" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">Vacantes visibles (GuruMatch web)
                    <small>Resultados antes del CTA Premium</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeGuruMatchVisible" min="1" max="20" class="cfg-input" style="width:70px;" placeholder="3">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">Vacantes visibles (alertas)
                    <small>Jobs en email/WA antes del CTA</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.freeAlertVisible" min="1" max="20" class="cfg-input" style="width:70px;" placeholder="2">
                </div>
                <!-- Canales -->
                <div style="margin-top:6px;padding-top:10px;border-top:1px solid #e2e8f0;">
                  <p style="font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.4px;margin:0 0 8px;">Canales de alerta</p>
                  <label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#334155;margin-bottom:6px;">
                    <input type="checkbox" [(ngModel)]="cfg.freeAlertEmail"> Email
                  </label>
                  <label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#334155;">
                    <input type="checkbox" [(ngModel)]="cfg.freeAlertWhatsapp"> WhatsApp
                  </label>
                </div>
              </div>
            </div>

            <!-- PREMIUM -->
            <div style="background:#eff6ff;border-radius:8px;padding:14px;border:1px solid #bfdbfe;">
              <p style="font-size:11px;font-weight:700;color:#1d4ed8;text-transform:uppercase;letter-spacing:.5px;margin:0 0 12px;">Plan Premium</p>
              <div style="display:flex;flex-direction:column;gap:10px;">
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">CVs almacenados
                    <small>Máximo de CVs guardados</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.premiumCvLimit" min="1" max="50" class="cfg-input" style="width:70px;" placeholder="5">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">Alertas / día
                    <small>Alertas automáticas recibidas por día</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.premiumAlertLimitDay" min="1" max="99" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">GuruMatch / día
                    <small>Usos del botón GuruMatch por día</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.premiumGuruMatchLimitDay" min="1" max="99" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <div>
                  <label class="cfg-label" style="margin-bottom:4px;">CV Optimizer / día
                    <small>Análisis de CV con IA por día</small>
                  </label>
                  <input type="number" [(ngModel)]="cfg.premiumCvOptimizerLimitDay" min="1" max="99" class="cfg-input" style="width:70px;" placeholder="1">
                </div>
                <!-- Canales -->
                <div style="margin-top:6px;padding-top:10px;border-top:1px solid #bfdbfe;">
                  <p style="font-size:11px;font-weight:700;color:#1d4ed8;text-transform:uppercase;letter-spacing:.4px;margin:0 0 8px;">Canales de alerta</p>
                  <label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#1e40af;margin-bottom:6px;">
                    <input type="checkbox" [(ngModel)]="cfg.premiumAlertEmail"> Email
                  </label>
                  <label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#1e40af;">
                    <input type="checkbox" [(ngModel)]="cfg.premiumAlertWhatsapp"> WhatsApp
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.ia.ok" class="cfg-ok">✓ {{sections.ia.ok}}</span>
            <span *ngIf="sections.ia.err" class="cfg-err">{{sections.ia.err}}</span>
          </div>
          <button (click)="guardar('ia')" [disabled]="sections.ia.saving" class="cfg-btn">
            <svg *ngIf="sections.ia.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.ia.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── Jobs automáticos (scraper + alertas) ─────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'automatizacion'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Jobs Automáticos</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Habilita o deshabilita el scraper diario y las alertas automáticas en este ambiente</p>
          </div>
        </div>
      </div>
      <div class="cfg-card__body">
        <!-- Fila: Scraper -->
        <div style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #f1f5f9;">
          <span style="width:130px;font-size:13px;font-weight:700;color:#0f172a;">Scraper diario</span>
          <button
            (click)="cfg.scraperHabilitado = true"
            [style.background]="cfg.scraperHabilitado ? '#059669' : '#e2e8f0'"
            [style.color]="cfg.scraperHabilitado ? '#fff' : '#64748b'"
            style="border:none;border-radius:8px 0 0 8px;padding:8px 18px;font-size:12px;font-weight:700;cursor:pointer;transition:background .2s;">
            ▶ ON
          </button>
          <button
            (click)="cfg.scraperHabilitado = false"
            [style.background]="!cfg.scraperHabilitado ? '#dc2626' : '#e2e8f0'"
            [style.color]="!cfg.scraperHabilitado ? '#fff' : '#64748b'"
            style="border:none;border-radius:0 8px 8px 0;padding:8px 18px;font-size:12px;font-weight:700;cursor:pointer;transition:background .2s;">
            ⏹ OFF
          </button>
          <span *ngIf="cfg.scraperHabilitado"  style="font-size:12px;color:#059669;font-weight:600;">Importará vacantes según el schedule configurado</span>
          <span *ngIf="!cfg.scraperHabilitado" style="font-size:12px;color:#dc2626;font-weight:600;">El scraper está pausado en este ambiente</span>
        </div>
        <!-- Fila: Alertas -->
        <div style="display:flex;align-items:center;gap:12px;padding:10px 0;">
          <span style="width:130px;font-size:13px;font-weight:700;color:#0f172a;">Alertas automáticas</span>
          <button
            (click)="cfg.alertasHabilitadas = true"
            [style.background]="cfg.alertasHabilitadas ? '#059669' : '#e2e8f0'"
            [style.color]="cfg.alertasHabilitadas ? '#fff' : '#64748b'"
            style="border:none;border-radius:8px 0 0 8px;padding:8px 18px;font-size:12px;font-weight:700;cursor:pointer;transition:background .2s;">
            ▶ ON
          </button>
          <button
            (click)="cfg.alertasHabilitadas = false"
            [style.background]="!cfg.alertasHabilitadas ? '#dc2626' : '#e2e8f0'"
            [style.color]="!cfg.alertasHabilitadas ? '#fff' : '#64748b'"
            style="border:none;border-radius:0 8px 8px 0;padding:8px 18px;font-size:12px;font-weight:700;cursor:pointer;transition:background .2s;">
            ⏹ OFF
          </button>
          <span *ngIf="cfg.alertasHabilitadas"  style="font-size:12px;color:#059669;font-weight:600;">Enviará alertas a usuarios según su frecuencia</span>
          <span *ngIf="!cfg.alertasHabilitadas" style="font-size:12px;color:#dc2626;font-weight:600;">Las alertas están pausadas en este ambiente</span>
        </div>
      </div>
      <div class="cfg-card__actions">
        <div class="cfg-feedback">
          <span *ngIf="sections.automaticos.ok"  class="cfg-ok">✓ {{sections.automaticos.ok}}</span>
          <span *ngIf="sections.automaticos.err" class="cfg-err">{{sections.automaticos.err}}</span>
        </div>
        <button (click)="guardar('automaticos')" [disabled]="sections.automaticos.saving" class="cfg-btn">
          <svg *ngIf="sections.automaticos.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
          </svg>
          {{ sections.automaticos.saving ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>

    <!-- ── Diagnóstico de alertas ────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'automatizacion'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0H3"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Diagnóstico de Alertas</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Estado del último run de alertas — útil para depurar por qué no llegan emails</p>
          </div>
        </div>
        <button (click)="cargarDiagnosticoAlertas()" style="font-size:12px;background:#7c3aed;color:#fff;border:none;border-radius:6px;padding:6px 14px;cursor:pointer;font-weight:600;">
          {{ diagCargando ? 'Cargando...' : 'Ver diagnóstico' }}
        </button>
      </div>
      <div class="cfg-card__body" *ngIf="alertDiag">
        <!-- Flags globales -->
        <div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px;">
          <span [style.background]="alertDiag.premiumAlertEmail ? '#dcfce7' : '#fee2e2'"
                [style.color]="alertDiag.premiumAlertEmail ? '#166534' : '#991b1b'"
                style="padding:3px 10px;border-radius:20px;font-size:12px;font-weight:700;">
            Email Premium: {{ alertDiag.premiumAlertEmail ? '✓ ON' : '✗ OFF' }}
          </span>
          <span [style.background]="alertDiag.premiumAlertWhatsapp ? '#dcfce7' : '#fee2e2'"
                [style.color]="alertDiag.premiumAlertWhatsapp ? '#166534' : '#991b1b'"
                style="padding:3px 10px;border-radius:20px;font-size:12px;font-weight:700;">
            WhatsApp Premium: {{ alertDiag.premiumAlertWhatsapp ? '✓ ON' : '✗ OFF' }}
          </span>
          <span style="background:#f1f5f9;color:#475569;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:600;">
            Límite/día: {{ alertDiag.premiumAlertLimitDay }}
          </span>
          <span style="background:#f1f5f9;color:#475569;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:600;">
            Score mín.: {{ alertDiag.guruMatchMinScore }}
          </span>
        </div>
        <!-- Último run por frecuencia -->
        <div *ngIf="alertDiag.ultimoRun" style="display:flex;flex-direction:column;gap:10px;">
          <div *ngFor="let key of objectKeys(alertDiag.ultimoRun)"
               style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px;">
            <p style="font-size:12px;font-weight:700;color:#334155;margin:0 0 8px;text-transform:uppercase;letter-spacing:.5px;">{{ key }}</p>
            <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:6px;font-size:12px;color:#475569;">
              <div><strong>Candidatos:</strong> {{ alertDiag.ultimoRun[key].candidatosTotal }}</div>
              <div><strong>Procesados:</strong> {{ alertDiag.ultimoRun[key].candidatosProcesados }}</div>
              <div><strong>Sin CV:</strong> {{ alertDiag.ultimoRun[key].candidatosSinCv }}</div>
              <div><strong>Vacantes disponibles:</strong> {{ alertDiag.ultimoRun[key].totalJobs }}</div>
              <div><strong>Alertas enviadas:</strong> {{ alertDiag.ultimoRun[key].alertasEnviadas }}</div>
              <div><strong>Email:</strong> {{ alertDiag.ultimoRun[key].alertasEmail }}</div>
              <div><strong>WhatsApp:</strong> {{ alertDiag.ultimoRun[key].alertasWhatsapp }}</div>
            </div>
            <div *ngIf="alertDiag.ultimoRun[key].motivosSkip" style="margin-top:8px;padding-top:8px;border-top:1px solid #e2e8f0;">
              <p style="font-size:11px;font-weight:700;color:#94a3b8;margin:0 0 4px;">Motivos de skip:</p>
              <div style="display:flex;flex-wrap:wrap;gap:4px;">
                <span *ngFor="let sk of objectEntries(alertDiag.ultimoRun[key].motivosSkip)"
                      style="background:#fef3c7;color:#92400e;padding:2px 8px;border-radius:12px;font-size:11px;font-weight:600;">
                  {{ sk[0] }}: {{ sk[1] }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="!alertDiag.ultimoRun || objectKeys(alertDiag.ultimoRun).length === 0"
           style="color:#94a3b8;font-size:13px;margin:0;">
          No hay runs registrados aún. Las alertas se ejecutan automáticamente según la hora configurada.
        </p>
      </div>
    </div>

    <!-- ── Free Onboarding (freebie) ─────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'automatizacion'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Free Onboarding (GuruMatch Gratuito)</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Configuración del GuruMatch gratuito de bienvenida para nuevos usuarios</p>
          </div>
        </div>
      </div>
      <div class="cfg-card__body">
        <div style="display:flex;flex-direction:column;gap:14px;">
          <div>
            <label class="cfg-label">Vacantes a mostrar
              <small>Cuántas vacantes del top se envían al usuario en su GuruMatch gratuito</small>
            </label>
            <div style="display:flex;align-items:center;gap:8px;">
              <input type="number" [(ngModel)]="cfg.freebieMatchCount" min="1" max="20" class="cfg-input"
                     style="width:80px;" placeholder="3">
              <span style="font-size:13px;color:#64748b;">vacantes</span>
            </div>
          </div>
          <div>
            <label class="cfg-label">Ventana de búsqueda (horas)
              <small>Vacantes publicadas en las últimas N horas se consideran para el freebie</small>
            </label>
            <div style="display:flex;align-items:center;gap:8px;">
              <input type="number" [(ngModel)]="cfg.freebieJobHours" min="1" max="720" class="cfg-input"
                     style="width:80px;" placeholder="72">
              <span style="font-size:13px;color:#64748b;">hora(s)</span>
            </div>
          </div>
          <div style="display:flex;justify-content:flex-end;margin-top:16px;padding-top:14px;border-top:1px solid #e2e8f0;">
            <button (click)="guardar('automaticos')" [disabled]="sections.automaticos.saving"
                    class="cfg-btn cfg-btn--primary">
              <span *ngIf="sections.automaticos.saving" class="cfg-spinner"></span>
              {{ sections.automaticos.saving ? 'Guardando…' : 'Guardar' }}
            </button>
            <span *ngIf="sections.automaticos.ok" style="color:#059669;font-size:13px;font-weight:600;margin-left:12px;align-self:center;">
              ✓ {{ sections.automaticos.ok }}
            </span>
            <span *ngIf="sections.automaticos.err" style="color:#dc2626;font-size:13px;font-weight:600;margin-left:12px;align-self:center;">
              ✗ {{ sections.automaticos.err }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ── SMTP / Correo ──────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'notificaciones'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#0ea5e9" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">SMTP — Envío de correos</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Verificación de cuentas, notificaciones y alertas</p>
          </div>
        </div>
        <span class="cfg-badge" [class.cfg-badge--ok]="cfg.smtpSet" [class.cfg-badge--warn]="!cfg.smtpSet">
          {{ cfg.smtpSet ? 'Configurado' : 'Sin configurar' }}
        </span>
      </div>

      <div class="cfg-card__body">
        <div style="display:flex;gap:12px;flex-wrap:wrap;">
          <div style="flex:2;min-width:180px;">
            <label class="cfg-label">Host SMTP</label>
            <input [(ngModel)]="cfg.smtpHost" type="text" class="cfg-input" placeholder="smtp.pepipost.com">
          </div>
          <div style="flex:1;min-width:90px;">
            <label class="cfg-label">Puerto</label>
            <input [(ngModel)]="cfg.smtpPort" type="text" class="cfg-input" placeholder="2525">
          </div>
        </div>

        <label class="cfg-label" style="margin-top:14px;">Usuario SMTP</label>
        <input [(ngModel)]="cfg.smtpUsername" type="text" class="cfg-input" placeholder="usuario@dominio.com">

        <label class="cfg-label" style="margin-top:14px;">Contraseña SMTP
          <small>Se enmascara al guardar.</small>
        </label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.smtpPassword" [type]="show['smtpPassword'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="••••••••">
          <button (click)="toggleShow('smtpPassword')" [disabled]="loadingTokens && !show['smtpPassword']" [title]="show['smtpPassword'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg *ngIf="!show['smtpPassword']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
            <svg *ngIf="show['smtpPassword']" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
          </button>
        </div>

        <div style="display:flex;gap:12px;flex-wrap:wrap;margin-top:14px;">
          <div style="flex:2;min-width:180px;">
            <label class="cfg-label">Correo remitente (From)</label>
            <input [(ngModel)]="cfg.smtpFrom" type="text" class="cfg-input" placeholder="empleos@tecgurus.net">
          </div>
          <div style="flex:2;min-width:160px;">
            <label class="cfg-label">Nombre remitente</label>
            <input [(ngModel)]="cfg.smtpFromName" type="text" class="cfg-input" placeholder="TG Empleos">
          </div>
        </div>

        <div class="cfg-card__actions">
          <div class="cfg-feedback">
            <span *ngIf="sections.smtp.ok" class="cfg-ok">✓ {{sections.smtp.ok}}</span>
            <span *ngIf="sections.smtp.err" class="cfg-err">{{sections.smtp.err}}</span>
          </div>
          <button (click)="guardar('smtp')" [disabled]="sections.smtp.saving" class="cfg-btn">
            <svg *ngIf="sections.smtp.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ sections.smtp.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>

        <!-- Test SMTP -->
        <div style="margin-top:16px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <p style="margin:0 0 10px;font-size:13px;font-weight:600;color:#0369a1;">Probar configuración SMTP</p>
          <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
            <input [(ngModel)]="smtpTestEmail" type="email" class="cfg-input" style="flex:1;min-width:200px;width:auto;" placeholder="correo-destino@ejemplo.com">
            <button (click)="testSmtp()" [disabled]="smtpTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;flex-shrink:0;">
              <svg *ngIf="smtpTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
              {{ smtpTesting ? 'Enviando...' : 'Enviar correo de prueba' }}
            </button>
          </div>
          <p *ngIf="smtpTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{smtpTestOk}}</p>
          <p *ngIf="smtpTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{smtpTestErr}}</p>
        </div>
      </div>
    </div>

    <!-- ── Redes Sociales — WordPress + Facebook + Instagram + LinkedIn + Imagen IA ── -->
    <div class="cfg-card" *ngIf="activeTab === 'social'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#db2777" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0-12.814a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0 12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Redes Sociales — Publicación automática con IA</p>
            <p style="margin:0;font-size:12px;color:#64748b;">WordPress, Facebook, Instagram, LinkedIn e imagen generada con OpenAI</p>
          </div>
        </div>
      </div>

      <div class="cfg-card__body">

        <!-- OpenAI (imagen) -->
        <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#0f172a;">Imagen IA — OpenAI</p>
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;font-size:12px;color:#475569;margin-bottom:10px;line-height:1.6;">
          <strong>Cómo obtener tu API Key de OpenAI:</strong>
          1) Entra a platform.openai.com/api-keys con tu cuenta. 2) Clic en "Create new secret key", dale un nombre
          (ej. "TG Empleos - Imágenes") y copia la key (empieza con "sk-...", solo se muestra una vez). 3) Pégala aquí y guarda.
          Se usa solo para generar la imagen de cada publicación con el modelo gpt-image-1. 4) Verifica que tengas
          facturación activa (Settings → Billing), de lo contrario las llamadas fallarán.
        </div>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.openaiApiKey" [type]="show['openaiApiKey'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="sk-...">
          <button (click)="toggleShow('openaiApiKey')" [disabled]="loadingTokens && !show['openaiApiKey']" [title]="show['openaiApiKey'] ? 'Ocultar' : 'Revelar'" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
          </button>
        </div>
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testOpenai()" [disabled]="oaTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="oaTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ oaTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="oaTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{oaTestOk}}</p>
          <p *ngIf="oaTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{oaTestErr}}</p>
        </div>

        <hr style="margin:20px 0;border:none;border-top:1px solid #e2e8f0;">

        <!-- WordPress -->
        <div style="display:flex;align-items:center;justify-content:space-between;">
          <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#0f172a;">WordPress</p>
          <div style="display:flex;align-items:center;gap:10px;">
            <label style="display:flex;align-items:center;gap:5px;font-size:12px;color:#475569;cursor:pointer;">
              <input type="checkbox" [(ngModel)]="cfg.wordpressEnabled"> Habilitado
            </label>
            <span class="cfg-badge" [class.cfg-badge--ok]="cfg.wordpressSet" [class.cfg-badge--warn]="!cfg.wordpressSet">
              {{ cfg.wordpressSet ? 'Configurado' : 'Sin configurar' }}
            </span>
          </div>
        </div>
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;font-size:12px;color:#475569;margin-bottom:10px;line-height:1.6;">
          <strong>Cómo obtener tus credenciales de WordPress:</strong>
          1) Inicia sesión en tu-dominio.com/wp-admin. 2) Ve a Usuarios → Perfil (o Tu perfil). 3) Baja hasta
          "Contraseñas de aplicación" (si no la ves, pide a tu hosting activarla o instala el plugin "Application Passwords").
          4) Escribe "TG Empleos" y clic en "Agregar nueva contraseña de aplicación". 5) Copia la contraseña TAL CUAL,
          con espacios (ej. "abcd 1234 efgh 5678"). 6) En "Usuario" pon tu username de login (no el correo).
          7) En "URL Base" pon tu sitio sin barra final (ej. https://tublog.com). 8) Usa "Probar conexión" antes de activar la publicación automática.
        </div>
        <div style="display:flex;gap:12px;flex-wrap:wrap;">
          <div style="flex:1;min-width:200px;">
            <label class="cfg-label">URL Base del sitio</label>
            <input [(ngModel)]="cfg.wordpressBaseUrl" type="text" class="cfg-input" placeholder="https://tublog.com">
          </div>
          <div style="flex:1;min-width:200px;">
            <label class="cfg-label">URL Base de la API</label>
            <input [(ngModel)]="cfg.wordpressApiBaseUrl" type="text" class="cfg-input" placeholder="https://tublog.com">
          </div>
        </div>
        <label class="cfg-label" style="margin-top:14px;">Usuario de WordPress</label>
        <input [(ngModel)]="cfg.wordpressUsername" type="text" class="cfg-input" placeholder="admin">
        <label class="cfg-label" style="margin-top:14px;">Contraseña de aplicación</label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.wordpressAppPassword" [type]="show['wordpressAppPassword'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="abcd 1234 efgh 5678">
          <button (click)="toggleShow('wordpressAppPassword')" [disabled]="loadingTokens && !show['wordpressAppPassword']" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
          </button>
        </div>
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testWordpress()" [disabled]="wpTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="wpTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ wpTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="wpTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{wpTestOk}}</p>
          <p *ngIf="wpTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{wpTestErr}}</p>
        </div>

        <hr style="margin:20px 0;border:none;border-top:1px solid #e2e8f0;">

        <!-- Facebook -->
        <div style="display:flex;align-items:center;justify-content:space-between;">
          <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#0f172a;">Facebook</p>
          <div style="display:flex;align-items:center;gap:10px;">
            <label style="display:flex;align-items:center;gap:5px;font-size:12px;color:#475569;cursor:pointer;">
              <input type="checkbox" [(ngModel)]="cfg.facebookEnabled"> Habilitado
            </label>
            <span class="cfg-badge" [class.cfg-badge--ok]="cfg.facebookSet" [class.cfg-badge--warn]="!cfg.facebookSet">
              {{ cfg.facebookSet ? 'Configurado' : 'Sin configurar' }}
            </span>
          </div>
        </div>
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;font-size:12px;color:#475569;margin-bottom:10px;line-height:1.6;">
          <strong>Cómo obtener el ID y el Token de tu Página de Facebook:</strong>
          1) Ve a developers.facebook.com y crea una App tipo "Negocios" (Mis Apps → Crear app).
          2) Abre el Graph API Explorer (developers.facebook.com/tools/explorer/). 3) Selecciona tu App, y en
          "User or Page" elige tu Página (debes ser admin). 4) En Permisos agrega: pages_show_list, pages_read_engagement,
          pages_manage_posts. Genera el token. 5) Ese token dura poco (1-2h) — para uno de larga duración (60 días) usa
          el Access Token Debugger (developers.facebook.com/tools/debug/accesstoken/) con "Extend Access Token", o para
          uno que no caduque genera un token de Sistema desde Business Manager → Usuarios del sistema. 6) Copia el token
          extendido abajo. 7) El "ID de la Página" está en Configuración de la página → General, o en la URL de
          facebook.com/tu-pagina/about. 8) Usa "Probar conexión" para confirmar.
        </div>
        <label class="cfg-label">ID de la Página de Facebook</label>
        <input [(ngModel)]="cfg.facebookPageId" type="text" class="cfg-input" placeholder="1234567890">
        <label class="cfg-label" style="margin-top:14px;">Token de Acceso de la Página</label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.facebookPageAccessToken" [type]="show['facebookPageAccessToken'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="EAAB...">
          <button (click)="toggleShow('facebookPageAccessToken')" [disabled]="loadingTokens && !show['facebookPageAccessToken']" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
          </button>
        </div>
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testFacebook()" [disabled]="fbTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="fbTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ fbTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="fbTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{fbTestOk}}</p>
          <p *ngIf="fbTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{fbTestErr}}</p>
        </div>

        <hr style="margin:20px 0;border:none;border-top:1px solid #e2e8f0;">

        <!-- Instagram -->
        <div style="display:flex;align-items:center;justify-content:space-between;">
          <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#0f172a;">Instagram</p>
          <div style="display:flex;align-items:center;gap:10px;">
            <label style="display:flex;align-items:center;gap:5px;font-size:12px;color:#475569;cursor:pointer;">
              <input type="checkbox" [(ngModel)]="cfg.instagramEnabled"> Habilitado
            </label>
            <span class="cfg-badge" [class.cfg-badge--ok]="cfg.instagramSet" [class.cfg-badge--warn]="!cfg.instagramSet">
              {{ cfg.instagramSet ? 'Configurado' : 'Sin configurar' }}
            </span>
          </div>
        </div>
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;font-size:12px;color:#475569;margin-bottom:10px;line-height:1.6;">
          <strong>Cómo vincular tu cuenta de Instagram:</strong>
          1) Convierte tu cuenta de Instagram a "Business" o "Creator" (Configuración → Cuenta). 2) Vincúlala a la
          misma Página de Facebook configurada arriba (Meta Business Suite → Configuración → Vinculación de cuentas).
          3) Reutiliza el mismo Token de Acceso de la Página de Facebook — Instagram Business no necesita un token propio.
          4) El "Instagram Business Account ID" se puede autodetectar: presiona "Probar conexión" abajo y, si ya vinculaste
          la cuenta, se autocompletará solo. Si prefieres ponerlo manualmente, lo encuentras vía Graph API Explorer
          consultando tu Página con el campo instagram_business_account.
        </div>
        <label class="cfg-label">Instagram Business Account ID</label>
        <input [(ngModel)]="cfg.instagramBusinessAccountId" type="text" class="cfg-input" placeholder="Se autodetecta al probar conexión, o pégalo aquí">
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testInstagram()" [disabled]="igTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="igTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ igTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="igTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{igTestOk}}</p>
          <p *ngIf="igTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{igTestErr}}</p>
        </div>

        <hr style="margin:20px 0;border:none;border-top:1px solid #e2e8f0;">

        <!-- LinkedIn -->
        <div style="display:flex;align-items:center;justify-content:space-between;">
          <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#0f172a;">LinkedIn</p>
          <div style="display:flex;align-items:center;gap:10px;">
            <label style="display:flex;align-items:center;gap:5px;font-size:12px;color:#475569;cursor:pointer;">
              <input type="checkbox" [(ngModel)]="cfg.linkedinEnabled"> Habilitado
            </label>
            <span class="cfg-badge" [class.cfg-badge--ok]="cfg.linkedinOrgSet" [class.cfg-badge--warn]="!cfg.linkedinOrgSet">
              {{ cfg.linkedinOrgSet ? 'Configurado' : 'Sin configurar' }}
            </span>
          </div>
        </div>
        <div style="background:#fef3c7;border:1px solid #fde68a;border-radius:8px;padding:10px 14px;font-size:12px;color:#78350f;margin-bottom:10px;line-height:1.7;">
          <strong>LinkedIn requiere aprobación previa — no es autoservicio inmediato como Facebook.</strong>
          1) Ve a linkedin.com/developers/apps y crea una App vinculada a tu Página de empresa (Organization Page).
          Nota: el LinkedIn Client ID/Secret que ya usas para "Iniciar sesión con LinkedIn" es OTRA cosa — no sirve para publicar.
          2) En la pestaña "Products" de tu App, solicita acceso a <strong>"Community Management API"</strong>.
          3) En el formulario de solicitud, describe el caso de uso así: <em>"Publicación automatizada de contenido
          orgánico (ofertas de empleo) en nuestra página de empresa, generado internamente, sin terceros ni bots de
          spam, con revisión de nuestro equipo sobre el contenido generado."</em> 4) Solicita específicamente el scope
          <strong>w_organization_social</strong>. 5) LinkedIn puede tardar de días a semanas en aprobar, y puede pedir
          una demo o video de tu app. 6) Una vez aprobado, genera el token con ese scope desde el flujo OAuth 2.0 de tu App.
          7) El "Organization ID" está en la URL del panel admin de tu página (linkedin.com/company/TU-EMPRESA/admin/ →
          el número en la URL). 8) Usa "Probar conexión" — si aún no te aprueban, fallará con un mensaje claro; esto NO
          bloquea el resto del sistema (WordPress/Facebook/Instagram funcionan independientemente).
        </div>
        <label class="cfg-label">Organization ID (URN, ej. urn:li:organization:12345)</label>
        <input [(ngModel)]="cfg.linkedinOrganizationId" type="text" class="cfg-input" placeholder="urn:li:organization:12345">
        <label class="cfg-label" style="margin-top:14px;">Access Token de la organización (scope w_organization_social)</label>
        <div style="display:flex;align-items:center;gap:6px;">
          <input [(ngModel)]="cfg.linkedinOrgAccessToken" [type]="show['linkedinOrgAccessToken'] ? 'text' : 'password'" class="cfg-input" style="flex:1;width:auto;" placeholder="AQV...">
          <button (click)="toggleShow('linkedinOrgAccessToken')" [disabled]="loadingTokens && !show['linkedinOrgAccessToken']" style="width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #cbd5e1;background:#f8fafc;border-radius:6px;cursor:pointer;color:#64748b;flex-shrink:0;padding:0;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" style="width:16px;height:16px;"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></svg>
          </button>
        </div>
        <div style="margin-top:12px;padding:14px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;">
          <button (click)="testLinkedin()" [disabled]="liTesting" style="display:inline-flex;align-items:center;gap:6px;background:#0ea5e9;color:#fff;border:none;border-radius:8px;padding:8px 16px;font-size:13px;font-weight:600;cursor:pointer;">
            <svg *ngIf="liTesting" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ liTesting ? 'Probando...' : 'Probar conexión' }}
          </button>
          <p *ngIf="liTestOk" style="margin:8px 0 0;font-size:12.5px;color:#16a34a;font-weight:600;">✓ {{liTestOk}}</p>
          <p *ngIf="liTestErr" style="margin:8px 0 0;font-size:12.5px;color:#dc2626;">{{liTestErr}}</p>
        </div>

        <!-- Toggle maestro -->
        <div style="margin-top:20px;padding:14px;background:#fef3c7;border:1px solid #fde68a;border-radius:8px;">
          <label style="display:flex;align-items:center;gap:10px;cursor:pointer;">
            <input type="checkbox" [(ngModel)]="cfg.autoPublishSocialEnabled">
            <span style="font-size:13px;font-weight:600;color:#92400e;">
              Activar publicación automática diaria (después de la última corrida del scraper del día, lunes a sábado,
              se publicará SIN aprobación manual en todos los canales configurados y probados exitosamente arriba)
            </span>
          </label>
        </div>

        <div class="cfg-card__actions" style="margin-top:16px;">
          <div class="cfg-feedback">
            <span *ngIf="sections.redesSociales.ok" class="cfg-ok">✓ {{sections.redesSociales.ok}}</span>
            <span *ngIf="sections.redesSociales.err" class="cfg-err">{{sections.redesSociales.err}}</span>
          </div>
          <button (click)="guardar('redesSociales')" [disabled]="sections.redesSociales.saving" class="cfg-btn">
            <svg *ngIf="sections.redesSociales.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;"><path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>
            {{ sections.redesSociales.saving ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── Prompts IA ────────────────────────────────────────────────────── -->
    <div class="cfg-card" *ngIf="activeTab === 'ia'">
      <div class="cfg-card__head">
        <div style="display:flex;align-items:center;gap:10px;">
          <svg viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="1.8" style="width:22px;height:22px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z"/>
          </svg>
          <div>
            <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Prompts de IA</p>
            <p style="margin:0;font-size:12px;color:#64748b;">Templates enviados al LLM y guardados en MongoDB</p>
          </div>
        </div>
      </div>

      <div class="cfg-card__body">

        <!-- Variables hint -->
        <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:10px 14px;font-size:12px;color:#475569;margin-bottom:16px;line-height:1.6;">
          <strong>Variables disponibles:</strong><br>
          <code style="color:#7c3aed;">Normalizador:</code> <code>&#123;titulo&#125;</code> <code>&#123;descripcion&#125;</code> <code>&#123;categorias&#125;</code><br>
          <code style="color:#7c3aed;">CV Optimizer:</code> <code>&#123;cvExtract&#125;</code> <code>&#123;marketTechs&#125;</code><br>
          <code style="color:#7c3aed;">Copy Redes Sociales:</code> <code>&#123;aperturasPrevias&#125;</code> <code>&#123;anguloVenta&#125;</code> <code>&#123;vacantes&#125;</code> <code>&#123;frasesProhibidas&#125;</code> <code>&#123;ordenesPrevios&#125;</code> <code>&#123;imagePromptsPrevios&#125;</code> <code>&#123;totalVacantesActivas&#125;</code><br>
          <code style="color:#7c3aed;">GuruMatch Extracción:</code> <code>&#123;cv&#125;</code><br>
          <code style="color:#7c3aed;">GuruMatch Scoring:</code> <code>&#123;candidateProfile&#125;</code> <code>&#123;vacantes&#125;</code>
        </div>

        <label class="cfg-label">Prompt Normalizador de Vacantes
          <small>Única fuente de verdad del filtro TI. Se guarda en MongoDB y es obligatorio.</small>
        </label>
        <textarea [(ngModel)]="cfg.promptNormalizador" rows="14" class="cfg-input"
                  required
                  style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                  placeholder="Prompt obligatorio almacenado en MongoDB..."></textarea>

        <label class="cfg-label" style="margin-top:20px;">Prompt CV Optimizer
          <small>Se usa al analizar el CV de un candidato contra el mercado.</small>
        </label>
        <textarea [(ngModel)]="cfg.promptCvOptimizer" rows="12" class="cfg-input"
                  style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                  placeholder="Dejar vacío para usar el prompt por defecto..."></textarea>
        <button (click)="resetPrompt('promptCvOptimizer')"
                style="background:transparent;border:1px solid #e2e8f0;border-radius:6px;color:#64748b;padding:4px 12px;font-size:12px;cursor:pointer;margin-top:6px;">
          Restaurar default
        </button>

        <label class="cfg-label" style="margin-top:20px;">Prompt Copy de Redes Sociales
          <small>Genera el copy diario (WordPress/Facebook/Instagram/LinkedIn) tras la última corrida del scraper.</small>
        </label>
        <textarea [(ngModel)]="cfg.promptSocialCopy" rows="14" class="cfg-input"
                  style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                  placeholder="Dejar vacío para usar el prompt por defecto..."></textarea>
        <button (click)="resetPrompt('promptSocialCopy')"
                style="background:transparent;border:1px solid #e2e8f0;border-radius:6px;color:#64748b;padding:4px 12px;font-size:12px;cursor:pointer;margin-top:6px;">
          Restaurar default
        </button>

        <label class="cfg-label" style="margin-top:20px;">Prompt GuruMatch — Extracción de perfil del CV
          <small>Extrae habilidades, nivel de seniority y años de experiencia del CV del candidato.</small>
        </label>
        <textarea [(ngModel)]="cfg.promptGuruMatchExtraccion" rows="10" class="cfg-input"
                  style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                  placeholder="Dejar vacío para usar el prompt por defecto..."></textarea>
        <button (click)="resetPrompt('promptGuruMatchExtraccion')"
                style="background:transparent;border:1px solid #e2e8f0;border-radius:6px;color:#64748b;padding:4px 12px;font-size:12px;cursor:pointer;margin-top:6px;">
          Restaurar default
        </button>

        <label class="cfg-label" style="margin-top:20px;">Prompt GuruMatch — Scoring candidato↔vacante
          <small>Calcula el % de compatibilidad. Usado por el botón GuruMatch y por las alertas automáticas.</small>
        </label>
        <textarea [(ngModel)]="cfg.promptGuruMatchScoring" rows="14" class="cfg-input"
                  style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                  placeholder="Dejar vacío para usar el prompt por defecto..."></textarea>
        <button (click)="resetPrompt('promptGuruMatchScoring')"
                style="background:transparent;border:1px solid #e2e8f0;border-radius:6px;color:#64748b;padding:4px 12px;font-size:12px;cursor:pointer;margin-top:6px;">
          Restaurar default
        </button>

        <div class="cfg-card__actions" style="margin-top:16px;">
          <div class="cfg-feedback">
            <span *ngIf="sections.prompts.ok" class="cfg-ok">✓ {{sections.prompts.ok}}</span>
            <span *ngIf="sections.prompts.err" class="cfg-err">{{sections.prompts.err}}</span>
          </div>
          <button (click)="guardar('prompts')" [disabled]="sections.prompts.saving" class="cfg-btn">
            <svg *ngIf="sections.prompts.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
            </svg>
            {{ sections.prompts.saving ? 'Guardando...' : 'Guardar prompts' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ── Bot WhatsApp Entrante ──────────────────────────────────────── -->
    <div *ngIf="activeTab === 'whatsappBot'">

      <!-- Card: Activación y Webhook -->
      <div class="cfg-card">
        <div class="cfg-card__head">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="font-size:26px;line-height:1;">🤖</span>
            <div>
              <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Bot de WhatsApp Entrante</p>
              <p style="margin:0;font-size:12px;color:#64748b;">Auto-registro de candidatos, subida de CV y GuruMatch freebie por chat</p>
            </div>
          </div>
          <span class="cfg-badge" [class.cfg-badge--ok]="cfg.whatsappBotEnabled" [class.cfg-badge--warn]="!cfg.whatsappBotEnabled">
            {{ cfg.whatsappBotEnabled ? 'Activo' : 'Inactivo' }}
          </span>
        </div>

        <div class="cfg-card__body">

          <!-- Toggle habilitado -->
          <label class="cfg-label">Estado del bot
            <small>Activa o desactiva el procesamiento de mensajes entrantes de WhatsApp.</small>
          </label>
          <div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">
            <button type="button"
                    (click)="cfg.whatsappBotEnabled = !cfg.whatsappBotEnabled"
                    [style.background]="cfg.whatsappBotEnabled ? '#16a34a' : '#94a3b8'"
                    style="-webkit-appearance:none;appearance:none;width:48px;height:26px;min-width:48px;padding:0;border:none;border-radius:999px;cursor:pointer;position:relative;transition:background .2s;">
              <span [style.left]="cfg.whatsappBotEnabled ? '24px' : '2px'"
                    style="position:absolute;top:2px;width:22px;height:22px;border-radius:50%;background:#fff;transition:left .2s;box-shadow:0 1px 3px rgba(0,0,0,.3);"></span>
            </button>
            <span style="font-size:13px;font-weight:600;" [style.color]="cfg.whatsappBotEnabled ? '#16a34a' : '#94a3b8'">
              {{ cfg.whatsappBotEnabled ? 'Habilitado' : 'Deshabilitado' }}
            </span>
          </div>

          <!-- Secreto del Webhook -->
          <label class="cfg-label">Secreto del Webhook
            <small>Token secreto en la URL del webhook. Configúralo en whatzmeapi como URL de callback.</small>
          </label>
          <div style="display:flex;gap:8px;align-items:stretch;">
            <input [(ngModel)]="cfg.whatsappWebhookSecret"
                   [type]="show['whatsappWebhookSecret'] ? 'text' : 'password'"
                   class="cfg-input" style="flex:1;margin-bottom:0;"
                   placeholder="ej. mi-secreto-super-seguro-123">
            <button type="button" (click)="toggleShow('whatsappWebhookSecret')"
                    style="flex-shrink:0;border:1px solid #e2e8f0;border-radius:8px;background:#f8fafc;color:#64748b;padding:0 12px;font-size:12px;cursor:pointer;white-space:nowrap;">
              {{ show['whatsappWebhookSecret'] ? 'Ocultar' : 'Mostrar' }}
            </button>
          </div>

          <!-- Palabra clave de activación -->
          <label class="cfg-label" style="margin-top:14px;">Palabra clave de activación
            <small>Inicia o reactiva el asistente cuando la sesión del número haya expirado. Vacío = sin filtro.</small>
          </label>
          <input [(ngModel)]="cfg.whatsappTriggerKeyword" type="text" class="cfg-input"
                 placeholder="ej. tg-empleos">

          <label class="cfg-label" style="margin-top:14px;">Duración de sesión (minutos)
            <small>Después de este tiempo sin mensajes se volverá a pedir la palabra clave. Usa 0 para que la sesión no expire.</small>
          </label>
          <input [(ngModel)]="cfg.whatsappSessionTimeoutMinutes" type="number" min="0" step="1"
                 class="cfg-input" placeholder="15">

          <!-- URL del webhook con botón copiar -->
          <div style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:8px;padding:12px 14px;margin-top:10px;margin-bottom:20px;">
            <p style="margin:0 0 6px;font-size:11px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.5px;">URL del Webhook (configurar en whatzmeapi)</p>
            <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;">
              <code style="font-size:11px;color:#0f172a;word-break:break-all;flex:1;">
                {{ webhookUrl }}
              </code>
              <button type="button" (click)="copyWebhookUrl()"
                      style="flex-shrink:0;border:1px solid #0ea5e9;border-radius:6px;background:#eff6ff;color:#0284c7;padding:4px 10px;font-size:12px;cursor:pointer;white-space:nowrap;">
                📋 Copiar URL
              </button>
            </div>
            <p style="margin:8px 0 0;font-size:11px;color:#64748b;">
              ℹ️ Esta URL va en <strong>whatzmeapi → Webhooks → URL de callback</strong>. El secreto actúa como token de seguridad.
            </p>
          </div>

          <div class="cfg-card__actions">
            <div class="cfg-feedback">
              <span *ngIf="sections.whatsappBot.ok" class="cfg-ok">✓ {{sections.whatsappBot.ok}}</span>
              <span *ngIf="sections.whatsappBot.err" class="cfg-err">{{sections.whatsappBot.err}}</span>
            </div>
            <button (click)="guardar('whatsappBot')" [disabled]="sections.whatsappBot.saving" class="cfg-btn">
              <svg *ngIf="sections.whatsappBot.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
              </svg>
              {{ sections.whatsappBot.saving ? 'Guardando...' : 'Guardar configuración' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Card: Prompts LLM -->
      <div class="cfg-card" style="margin-top:20px;">
        <div class="cfg-card__head">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="font-size:22px;">🧠</span>
            <div>
              <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Prompts del Bot (DeepSeek / Claude)</p>
              <p style="margin:0;font-size:12px;color:#64748b;">Personaliza cómo el LLM clasifica mensajes y redacta respuestas</p>
            </div>
          </div>
          <span class="cfg-badge" [class.cfg-badge--ok]="cfg.deepseekSet" [class.cfg-badge--warn]="!cfg.deepseekSet">
            {{ cfg.deepseekSet ? 'IA configurada' : 'Sin clave IA' }}
          </span>
        </div>

        <div class="cfg-card__body">
          <div style="background:#fef3c7;border:1px solid #fcd34d;border-radius:8px;padding:10px 14px;margin-bottom:20px;font-size:12px;color:#92400e;">
            ⚠️ El bot usa la misma clave de DeepSeek configurada en la pestaña <strong>Inteligencia Artificial</strong>.
            Deja los prompts vacíos para usar los prompts por defecto del sistema.
          </div>

          <!-- Prompt: Clasificación de intención -->
          <label class="cfg-label">Prompt — Clasificación de intención
            <small>El LLM recibe el mensaje de WhatsApp y devuelve un JSON con <code>intencion</code> (ENVIA_CV, QUIERE_VACANTES, SALUDO, CONFIRMA_SI, CONFIRMA_NO, OTRO) y <code>resumen</code>.
            Si este campo está <strong>vacío</strong>, el bot usa heurística simple sin LLM hasta que el admin lo configure.</small>
          </label>
          <textarea [(ngModel)]="cfg.promptWhatsappIntent" rows="16" class="cfg-input"
                    style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                    placeholder="Escribe el prompt aquí o usa 'Restaurar canónico' para cargar el texto recomendado..."></textarea>
          <div style="display:flex;gap:8px;margin-top:6px;flex-wrap:wrap;align-items:center;">
            <span style="font-size:11px;color:#94a3b8;">
              Variables disponibles: <code>&#123;mensaje&#125;</code>, <code>&#123;tieneDocumentoAdjunto&#125;</code>
            </span>
          </div>

          <!-- Prompt: Redacción de respuesta -->
          <label class="cfg-label" style="margin-top:24px;">Prompt — Redacción de respuesta
            <small>El LLM recibe el resultado real calculado por el código (situación) y lo redacta en tono conversacional.
            Si está <strong>vacío</strong>, el bot envía el texto de sistema directamente sin procesar con LLM.</small>
          </label>
          <textarea [(ngModel)]="cfg.promptWhatsappReply" rows="14" class="cfg-input"
                    style="font-family:monospace;font-size:12px;line-height:1.5;resize:vertical;"
                    placeholder="Escribe el prompt aquí o usa 'Restaurar canónico' para cargar el texto recomendado..."></textarea>
          <div style="display:flex;gap:8px;margin-top:6px;flex-wrap:wrap;align-items:center;">
            <span style="font-size:11px;color:#94a3b8;">
              Variables: <code>&#123;nombre&#125;</code>, <code>&#123;mensaje&#125;</code>, <code>&#123;situacion&#125;</code>
            </span>
          </div>

          <!-- Botón único para restaurar ambos prompts en Mongo -->
          <div style="margin-top:14px;padding:12px 14px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
            <span style="font-size:12px;color:#166534;flex:1;">Restaura los dos prompts al texto canónico y los guarda en MongoDB. El bot los usa inmediatamente.</span>
            <button (click)="restaurarPromptsWhatsapp()" [disabled]="waBotResetting"
                    style="flex-shrink:0;border:1px solid #16a34a;border-radius:6px;background:#dcfce7;color:#15803d;padding:6px 14px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
              {{ waBotResetting ? 'Restaurando...' : '🔄 Restaurar canónico en MongoDB' }}
            </button>
          </div>
          <!-- Diagrama del flujo -->
          <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:16px;margin-top:24px;">
            <p style="margin:0 0 10px;font-size:12px;font-weight:700;color:#0f172a;">📋 Flujo del bot (referencia)</p>
            <div style="font-size:12px;color:#475569;line-height:1.8;">
              <p style="margin:0;"><strong>1. Mensaje entrante</strong> → LLM clasifica intención (ENVIA_CV / QUIERE_VACANTES / SALUDO / ...)</p>
              <p style="margin:0;"><strong>2. Código decide acción</strong> → guardar CV, correr GuruMatch, crear candidato, etc.</p>
              <p style="margin:0;"><strong>3. LLM redacta respuesta</strong> → texto amigable en base al resultado real</p>
              <p style="margin:0;"><strong>4. Bot responde</strong> → mensaje enviado por WhatsApp vía whatzmeapi</p>
            </div>
          </div>

          <div class="cfg-card__actions" style="margin-top:16px;">
            <div class="cfg-feedback">
              <span *ngIf="sections.whatsappBot.ok" class="cfg-ok">✓ {{sections.whatsappBot.ok}}</span>
              <span *ngIf="sections.whatsappBot.err" class="cfg-err">{{sections.whatsappBot.err}}</span>
            </div>
            <button (click)="guardar('whatsappBot')" [disabled]="sections.whatsappBot.saving" class="cfg-btn">
              <svg *ngIf="sections.whatsappBot.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
              </svg>
              {{ sections.whatsappBot.saving ? 'Guardando...' : 'Guardar prompts' }}
            </button>
          </div>
        </div>
      </div>

    </div><!-- /whatsappBot -->

    <!-- ── Google Indexing API ───────────────────────────────────────── -->
    <div *ngIf="activeTab === 'googleIndexing'">

      <div class="cfg-card">
        <div class="cfg-card__head">
          <div style="display:flex;align-items:center;gap:10px;">
            <span style="font-size:26px;line-height:1;">⚡</span>
            <div>
              <p style="margin:0;font-size:14px;font-weight:700;color:#0f172a;">Google Indexing API (Google for Jobs)</p>
              <p style="margin:0;font-size:12px;color:#64748b;">Indexación instantánea de vacantes creadas, modificadas o cerradas</p>
            </div>
          </div>
          <span class="cfg-badge" [class.cfg-badge--ok]="cfg.googleIndexingSet" [class.cfg-badge--warn]="!cfg.googleIndexingSet">
            {{ cfg.googleIndexingSet ? 'Configurado' : 'Sin credencial' }}
          </span>
        </div>

        <div class="cfg-card__body">

          <!-- Toggle habilitado -->
          <label class="cfg-label">Estado de la Indexación Instantánea
            <small>Notifica a Google Indexing API automáticamente cuando el scraper o admin publica o despublica vacantes.</small>
          </label>
          <div style="display:flex;align-items:center;gap:12px;margin-bottom:20px;">
            <button type="button"
                    (click)="cfg.googleIndexingEnabled = !cfg.googleIndexingEnabled"
                    [style.background]="cfg.googleIndexingEnabled ? '#16a34a' : '#94a3b8'"
                    style="width:48px;height:26px;border:none;border-radius:999px;cursor:pointer;position:relative;transition:background .2s;">
              <span [style.left]="cfg.googleIndexingEnabled ? '24px' : '2px'"
                    style="position:absolute;top:2px;width:22px;height:22px;border-radius:50%;background:#fff;transition:left .2s;box-shadow:0 1px 3px rgba(0,0,0,.3);"></span>
            </button>
            <span style="font-size:13px;font-weight:600;" [style.color]="cfg.googleIndexingEnabled ? '#16a34a' : '#94a3b8'">
              {{ cfg.googleIndexingEnabled ? 'Habilitado' : 'Deshabilitado' }}
            </span>
          </div>

          <!-- Credencial JSON Service Account -->
          <label class="cfg-label">Service Account JSON (Google Cloud Console)
            <small>Contenido completo del archivo JSON descargado de Google Cloud Console con la Web Search Indexing API habilitada.</small>
          </label>
          <div style="margin-bottom:12px;">
            <textarea [(ngModel)]="cfg.googleIndexingServiceAccountJson" rows="8" class="cfg-input"
                      style="font-family:monospace;font-size:11px;line-height:1.4;resize:vertical;"
                      placeholder="{ 'type': 'service_account', 'project_id': '...', 'private_key': '...' }"></textarea>
          </div>

          <!-- Botones de Acción / Prueba -->
          <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:20px;">
            <button type="button" (click)="testGoogleIndexing()" [disabled]="giTesting"
                    style="border:1px solid #0ea5e9;border-radius:8px;background:#f0f9ff;color:#0369a1;padding:8px 16px;font-size:12px;font-weight:600;cursor:pointer;">
              {{ giTesting ? 'Probando...' : '🧪 Probar Google Indexing API' }}
            </button>

            <button type="button" (click)="indexAllVacancies()" [disabled]="giBatching"
                    style="border:1px solid #8b5cf6;border-radius:8px;background:#f5f3ff;color:#6d28d9;padding:8px 16px;font-size:12px;font-weight:600;cursor:pointer;">
              {{ giBatching ? 'Indexando...' : '🚀 Indexar todas las vacantes activas en Google' }}
            </button>
          </div>

          <div *ngIf="giTestOk" style="background:#f0fdf4;border:1px solid #bbf7d0;color:#15803d;padding:10px 14px;border-radius:8px;font-size:12px;margin-bottom:16px;">
            ✓ {{ giTestOk }}
          </div>
          <div *ngIf="giTestErr" style="background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;padding:10px 14px;border-radius:8px;font-size:12px;margin-bottom:16px;">
            ⚠️ {{ giTestErr }}
          </div>

          <div *ngIf="giBatchOk" style="background:#f0fdf4;border:1px solid #bbf7d0;color:#15803d;padding:10px 14px;border-radius:8px;font-size:12px;margin-bottom:16px;">
            ✓ {{ giBatchOk }}
          </div>
          <div *ngIf="giBatchErr" style="background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;padding:10px 14px;border-radius:8px;font-size:12px;margin-bottom:16px;">
            ⚠️ {{ giBatchErr }}
          </div>

          <div class="cfg-card__actions">
            <div class="cfg-feedback">
              <span *ngIf="sections.googleIndexing.ok" class="cfg-ok">✓ {{sections.googleIndexing.ok}}</span>
              <span *ngIf="sections.googleIndexing.err" class="cfg-err">{{sections.googleIndexing.err}}</span>
            </div>
            <button (click)="guardar('googleIndexing')" [disabled]="sections.googleIndexing.saving" class="cfg-btn">
              <svg *ngIf="sections.googleIndexing.saving" class="cfg-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:14px;height:14px;">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
              </svg>
              {{ sections.googleIndexing.saving ? 'Guardando...' : 'Guardar configuración' }}
            </button>
          </div>

        </div>
      </div>

    </div><!-- /googleIndexing -->

  </div>
</div>
